import { LocaleService } from '../services/locale.service';
import { GenericField } from './generic-field';

export class GenericFieldNumber extends GenericField{
	value: number;

	constructor(formatter: LocaleService, key: string, type: string, value?: number){
		super();
		this.key = key;
		this.type = type;
		if(value){
			this.value = value;
		}else{
			this.clear();
		}
		this.toString(formatter);
    }

	clear(){
		this.value = 0.00;
	}

	getValue(){
		return this.value;
	}

	setValue(value: number){
		if(value){
			this.value = value;
		}else{
			this.clear();
		}
	}

	toString(formatter: LocaleService){
		if(this.type == 'currency'){
			this.valueString = formatter.toCurrency(this.value.toString());
		}else{
			this.valueString = this.value.toString();
		}
	}
}
